export default __webpack_public_path__ + "static/media/restart.0c7542ac.svg";